// RESPONSIVE VIDEO!
// PAUSE OUT-OF-VIEW VIDEO
// GSAP
// SLIDER (SWIPER JS)


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}


//
// =PAUSE OUT-OF-VIEW VIDEO
// --------------------------------------------------

const videos = document.querySelectorAll("video");

const config = {
  rootMargin: '0px -100px',
  threshold: 0
}

const callback = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      entry.target.pause();
      // alert('Exit video');
    } else {
      entry.target.play();
      // alert('Enter video');
    }
  });
}

const vidsObserver = new IntersectionObserver(callback, config);

videos.forEach(element => {
  vidsObserver.observe(element);
});


//
// =GSAP
// --------------------------------------------------

if (window.matchMedia(`(prefers-reduced-motion: no-preference)`) === true ||
  window.matchMedia(`(prefers-reduced-motion: no-preference)`).matches === true) {

  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.config({
    autoRefreshEvents: "DOMContentLoaded,load,resize",
  });

  const cards = gsap.utils.toArray(".msdw-scroller > figure");
  const numCards = cards.length - 1;

  gsap.to('.msdw-scroller', {
    xPercent: -100 * numCards,
    ease: "none",
    scrollTrigger: {
      trigger: '.msdw-pin-wrapper',
      pin: true,
      scrub: true,
      start: "top 60px",
      end: () => `+=${window.innerWidth * 2}`,
      // markers: true,
    }
  });
}

window.addEventListener('resize', () => ScrollTrigger.refresh());


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const genderSliders = document.querySelectorAll('.msdw-swiper-slider');

genderSliders.forEach((genderSlider) => {
  new Swiper (genderSlider, {
    noSwipingClass: "swiper-no-swiping",
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 150,
    loop: false,
    autoHeight: true,
    navigation: {
      prevEl: genderSlider.previousSibling.querySelector('.msdw-slider-arrows').querySelector('.msdw-swiper-button-prev'),
      nextEl: genderSlider.previousSibling.querySelector('.msdw-slider-arrows').querySelector('.msdw-swiper-button-next'),
    },
    on: {
      slideChangeTransitionEnd: () => ScrollTrigger.refresh()
    },
  });
});
